import { DOG_SIZE_FIELD, PET_SIZES_FIELDS } from '@rover/shared/js/constants/searchPage.constants';
import { searchFilterKeysMap } from '@rover/shared/js/search/utilities/searchFiltersMap';
import { SearchFilters } from '@rover/types';
import { DateRange } from '@rover/types/src/datetime/DateRange';

/**
 * @desription Historically the web search page used pet size parameters in the format of
  small_dogs=true. This is different from how the mobile apps work
  and incompatible with the API. The API expects these parameters in the
  format: dog_size=small. In order to support pages that might link to
  search with the old small_dogs=true, and be compatible with the expected
  API behavior, we convert the old style parameters to the newer style in
  this  method.

  API expects dog_size=<small, medium, large, giant>
  frontend might have small_dogs=true or large_dogs=true
  need to detect and translate
 * @param searchParams 
 * @param cleanedFilters 
 */
export const setPetSizes = (
  searchParams: URLSearchParams,
  cleanedFilters: Partial<SearchFilters & { dateRange: DateRange }>
): void => {
  PET_SIZES_FIELDS.forEach((petSizeKey) => {
    const sizeExistsAndIsTrue = petSizeKey in cleanedFilters && cleanedFilters[petSizeKey];
    if (sizeExistsAndIsTrue) {
      searchParams.append(searchFilterKeysMap[DOG_SIZE_FIELD], petSizeKey.replace('Dogs', ''));
    }
  });
};
